import { getVotingTokenOptions } from "../../api/utils";
import React, { useEffect, useState } from "react";
import { PayoutTokenDropdown } from "./PayoutTokenDropdown";
import { ApplyTooltip } from "./ApplyTooltip";
import { RoundInCart } from "./RoundInCart";
import { useTokenPrice, stringToBlobUrl, getChainById } from "common";
import { Button, Input } from "common/src/styles";
import { useCartStorage } from "../../../store";
import { ArrowRightIcon, ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CartWithProjects(_ref) {
  let {
    cart,
    chainId,
    totalAmount,
    balances,
    payoutToken,
    enoughBalance,
    handleSwap
  } = _ref;
  const chain = getChainById(chainId);
  const cartByRound = Object.values(cart);
  const store = useCartStorage();
  const [fixedDonation, setFixedDonation] = useState("");
  const {
    setVotingTokenForChain
  } = useCartStorage();
  const payoutTokenOptions = getVotingTokenOptions(Number(chainId)).filter(p => p.canVote);
  const {
    data,
    error,
    loading
  } = useTokenPrice(payoutToken.redstoneTokenId, payoutToken.priceSource);
  const payoutTokenPrice = !loading && !error ? Number(data) : null;

  // get number of projects in cartByRound
  const projectCount = cartByRound.reduce((acc, curr) => acc + curr.length, 0);

  /** The payout token data (like permit version etc.) might've changed since the user last visited the page
   * Refresh it to update, default to the first payout token if the previous token was deleted */
  useEffect(() => {
    var _getVotingTokenOption;
    setVotingTokenForChain(chainId, (_getVotingTokenOption = getVotingTokenOptions(chainId).find(token => token.address === payoutToken.address)) !== null && _getVotingTokenOption !== void 0 ? _getVotingTokenOption : getVotingTokenOptions(chainId)[0]);
    /* We only want this to happen on first render */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId]);
  return /*#__PURE__*/_jsxs("div", {
    className: "grow block px-[16px] lg:pl-0 py-4 bg-white",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-col md:flex-row justify-between border-b-2 pb-2 gap-3 mb-6",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-row gap-2 items-center",
        children: [/*#__PURE__*/_jsx("img", {
          className: "inline-block h-8 w-8",
          src: stringToBlobUrl(chain.icon),
          alt: "Chain Logo"
        }), /*#__PURE__*/_jsx("h2", {
          className: "text-xl sm:text-2xl font-semibold",
          children: chain.prettyName
        }), /*#__PURE__*/_jsxs("h2", {
          className: "text-xl sm:text-2xl font-semibold",
          children: ["(", projectCount, ")"]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "hidden sm:flex flex-col sm:flex-row justify-center sm:justify-end gap-3 sm:gap-2 basis-[72%]",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-2 sm:gap-4",
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-xs md:text-sm amount-text font-medium",
            children: "Amount"
          }), /*#__PURE__*/_jsx(Input, {
            "aria-label": "Donation amount for all projects ",
            id: "input-donationamount",
            min: "0",
            type: "number",
            value: fixedDonation !== null && fixedDonation !== void 0 ? fixedDonation : "",
            onChange: e => {
              setFixedDonation(e.target.value);
            },
            className: "w-24 sm:w-16 lg:w-18 max-h-10",
            placeholder: "0"
          }), /*#__PURE__*/_jsx(PayoutTokenDropdown, {
            selectedPayoutToken: payoutToken,
            setSelectedPayoutToken: token => {
              setVotingTokenForChain(chainId, token);
            },
            payoutTokenOptions: payoutTokenOptions,
            balances: balances,
            balanceWarning: !enoughBalance
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center justify-end sm:ml-2",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "button",
            $variant: "outline",
            onClick: () => {
              store.updateDonationsForChain(chainId, fixedDonation);
            },
            className: "text-sm py-2 px-3 text-blue-200 border border-blue-200 rounded h-10 mr-1",
            children: "Apply to all"
          }), /*#__PURE__*/_jsx(ApplyTooltip, {})]
        })]
      })]
    }), totalAmount > 0 && !enoughBalance && /*#__PURE__*/_jsx("div", {
      className: "flex flex-row justify-between my-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "rounded-md bg-red-50 py-2 text-pink-500 flex flex-col sm:flex-row items-center text-sm p-5 w-full justify-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center mb-4 sm:mb-0",
          children: [/*#__PURE__*/_jsx(ExclamationCircleIcon, {
            className: "w-6 h-6 mr-2"
          }), /*#__PURE__*/_jsxs("span", {
            className: "p-2 pr-4 sm:flex-1",
            children: [/*#__PURE__*/_jsx("span", {
              className: "hidden sm:inline",
              children: "You do not have enough funds in your wallet to complete this donation."
            }), /*#__PURE__*/_jsx("span", {
              className: "sm:hidden",
              children: "Insufficient funds on Arbitrum"
            }), /*#__PURE__*/_jsx("br", {
              className: "hidden sm:block"
            }), /*#__PURE__*/_jsx("span", {
              className: "hidden sm:inline",
              children: "Please bridge funds to this network in order to submit your donation."
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          onClick: () => handleSwap(),
          className: "flex items-center justify-center text-sm decoration-1 cursor-pointer rounded border font-semibold py-3 px-4 border-pink-500 min-h-[44px] w-full sm:w-auto",
          children: ["Bridge Funds", /*#__PURE__*/_jsx(ArrowRightIcon, {
            className: "h-4 w-4 ml-2"
          })]
        })]
      })
    }), cartByRound.map((roundcart, key) => /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(RoundInCart, {
        roundCart: roundcart,
        handleRemoveProjectFromCart: store.remove,
        selectedPayoutToken: payoutToken,
        payoutTokenPrice: payoutTokenPrice !== null && payoutTokenPrice !== void 0 ? payoutTokenPrice : 0
      }, key)
    }, key))]
  });
}